<script setup>
defineProps({ label: { type: String, default: '' }, size: { type: String, default: 'md' } })
</script>

<template>
  <span class="inline-flex items-center gap-2 text-faint" role="status">
    <i :class="['fa-solid fa-circle-notch fa-spin', size === 'lg' ? 'text-2xl' : size === 'sm' ? 'text-xs' : '']" aria-hidden="true"></i>
    <span v-if="label">{{ label }}</span>
  </span>
</template>
